import React from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import AddAdmin from "./AddAdmin";

export interface Administrator {
    admin_id: number
    first_name: string
    last_name: string
    email_address: string
    username: string
}

const initialAdmin: Administrator = {
    admin_id: 0, email_address: "", first_name: "", last_name: "", username: ""
}

export default function Administrators() {
    const [administrators, setAdministrators] = React.useState<Administrator[]>([])
    const [showAdmin, setShowAdmin] = React.useState({show: false, admin: initialAdmin})
    const {showMessage} = useAlert()

    const getAdministrators = () => {
        Utils.toggleSpinner('show')
        AppApi.getAdministrators()
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    setAdministrators(res.data.administrators)
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error while loading administrators', type: 'error'})
            })
    }

    React.useEffect(() => {
        getAdministrators()
    }, [])

    return (
        <>
            <div className={'action_container'}>
                <span className={'action_btn'} onClick={() => setShowAdmin({admin: initialAdmin, show: true})}>Add New</span>
                <span className={'action_btn'} onClick={getAdministrators}>Load List</span>
            </div>

            <div className="table-responsive table_container">
                <table id="example" className="table table-striped" style={{width: '100%'}}>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Username</th>
                            <th>Email Address</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            administrators.map((administrator: Administrator) =>
                                <tr key={administrator.admin_id}>
                                    <td>{administrator.first_name}</td>
                                    <td>{administrator.last_name}</td>
                                    <td>{administrator.username}</td>
                                    <td>{administrator.email_address}</td>
                                    <td>
                                        <span className={'action_btn'}
                                              onClick={() => setShowAdmin({show: true, admin: administrator})}>
                                            Edit
                                        </span>
                                        <span className={'action_btn'}>Delete</span>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            <AddAdmin
                show={showAdmin.show} admin={showAdmin.admin}
                close={(administrator) => {
                    if (administrator !== undefined) {
                        if (showAdmin.admin.admin_id === 0) {
                            setAdministrators([administrator, ...administrators])
                        } else {
                            setAdministrators(administrators.map(aAdmin =>
                                aAdmin.admin_id === administrator.admin_id ? administrator : aAdmin))
                        }
                    }
                    setShowAdmin({admin: initialAdmin, show: false})
                }}/>
        </>
    )
}